import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import division from "../../../containers/modules/hr/division";

export default function DivisionRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="division"
      index
      element={
        <AccessControl
          name={"Division List"}
          auth={authUser}
          component={division}
        />
      }
    ></Route>
  );
}
